import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const RedirectToProfile = () => {
  const { profileId } = useParams();
  return <Navigate to={`/profile/${profileId}`} />;
};

export default RedirectToProfile;
